import { Card, Skeleton } from 'antd';

import { PREFIX } from '@app/constants/appPrefix';
import {
  EmailInfo,
  MainInfo,
  OrganizationInfo,
  PasswordInfo,
  PersonalInfo,
  PhoneInfo,
} from '@app/pages/Users/UserProfile/components';
import { SalaryInfo } from '@app/pages/Users/UserProfile/components/SalaryInfo';
import { useUserProfile } from '@app/pages/Users/UserProfile/hooks/useUserProfile';

import type { FC } from 'react';

import '@app/pages/Users/UserProfile/styles/UserProfile.desktop.scss';
import '@app/pages/Users/UserProfile/styles/UserProfile.tablet.scss';
import '@app/pages/Users/UserProfile/styles/UserProfile.mobile.scss';

export const UserProfile: FC = () => {
  const {
    isLoader,
    currentUser,
    isModalOpen,
    showModal,
    uploadAvatar,
    deleteAvatar,
    newPhoto,
    positions,
    submitMainForm,
    currentPhoneNumber,
    updatePhoneNumber,
    currentEmail,
    updateEmail,
    emailServerError,
    setEmailServerError,
    mainInfoServerError,
    setMainInfoServerError,
    submitPasswordForm,
    passwordServerError,
    setPasswordServerError,
    addPosition,
    isPositionsModalOpen,
    handlePositionsOk,
    handlePositionsCancel,
    modalPositionsForm,
    finishPositionsModal,
    mainForm,
    hasUserRightToCreate,
    setIsModalOpen,
    telForm,
    handlePhone,
    setPhoneValidation,
    phoneValidation,
  } = useUserProfile();

  if (isLoader) {
    return <Skeleton active />;
  }

  if (!currentUser) {
    return;
  }

  return (
    <div className={`${PREFIX}user-profile`}>
      <div className="user-profile-col user-profile-col-left">
        <Card
          title={
            <span data-testid="user-name">{`${currentUser?.NameFirst} ${currentUser?.NameLast}`}</span>
          }
          className="personal-info"
        >
          <PersonalInfo
            currentUser={currentUser}
            isModalOpen={isModalOpen}
            showModal={showModal}
            uploadAvatar={uploadAvatar}
            deleteAvatar={deleteAvatar}
            newPhoto={newPhoto}
            setIsModalOpen={setIsModalOpen}
            currentPhoneNumber={handlePhone(currentPhoneNumber)}
          />
        </Card>

        <Card
          title={
            <span data-testid="change-password-title">Изменить пароль</span>
          }
          className="password-info"
        >
          <PasswordInfo
            serverError={passwordServerError}
            setServerError={setPasswordServerError}
            submitPasswordForm={submitPasswordForm}
          />
        </Card>

        <Card
          title={<span data-testid="salary-title">Заработная плата</span>}
          className="salary-info"
        >
          <SalaryInfo />
        </Card>

        <Card
          title={<span data-testid="organization-title">Организация</span>}
          className="organization-info"
        >
          <OrganizationInfo isLoading={isLoader} currentUser={currentUser} />
        </Card>
      </div>

      <div className="user-profile-col user-profile-col-right">
        <Card
          title={<span data-testid="main-data-title">Основные данные</span>}
          className="main-info"
        >
          <MainInfo
            currentUser={currentUser}
            positions={positions}
            submitMainForm={submitMainForm}
            serverError={mainInfoServerError}
            setServerError={setMainInfoServerError}
            addPosition={addPosition}
            isPositionsModalOpen={isPositionsModalOpen}
            handlePositionsOk={handlePositionsOk}
            handlePositionsCancel={handlePositionsCancel}
            modalPositionsForm={modalPositionsForm}
            finishPositionsModal={finishPositionsModal}
            mainForm={mainForm}
            hasUserRightToCreate={hasUserRightToCreate}
          />
        </Card>

        <Card
          title={
            <span data-testid="change-mobile-title">
              Изменить номер мобильного
            </span>
          }
          className="phone"
        >
          <PhoneInfo
            telForm={telForm}
            currentPhoneNumber={currentPhoneNumber}
            updatePhoneNumber={updatePhoneNumber}
            setPhoneValidation={setPhoneValidation}
            phoneValidation={phoneValidation}
          />
        </Card>

        <Card
          title={<span data-testid="change-email-title">Изменить email</span>}
          className="email"
        >
          <EmailInfo
            currentEmail={currentEmail}
            updateEmail={updateEmail}
            serverError={emailServerError}
            setServerError={setEmailServerError}
          />
        </Card>
      </div>
    </div>
  );
};
